import { MainSection } from "@/styles/global";
import React from "react";
import S from "./CtaBlock.styled";
import Button from "@/components/global-components/Button";
import { IWPLink } from "@/src/types";

export type CtaBlockProps = {
  position: string;
  color: string;
  title: string;
  text: string;
  link: IWPLink;
};

const CtaBlock: React.FC<CtaBlockProps> = ({
  position,
  color,
  text,
  title,
  link,
}) => {
  return (
    <MainSection $bgColor={color}>
      <S.Inner>
        <S.TextWrapper $position={position}>
          {title && <S.Title $position={position}>{title}</S.Title>}
          {text && <S.Text>{text}</S.Text>}
          {link && (
            <S.LinkWrapper>
              <Button link={link} type="primary" arrow />
            </S.LinkWrapper>
          )}
        </S.TextWrapper>
      </S.Inner>
    </MainSection>
  );
};

export default CtaBlock;
